import { Typography as MUITypography, styled } from "@mui/material";
import { lineHeight, rem } from "utils";

import { TypographyProps } from "./Typography.types";

export const Container = styled(MUITypography)<TypographyProps>(
  ({ type, disabled, theme }) => {
    let styleBasedOnType = {};
    switch (type) {
      case "Display2XL": {
        styleBasedOnType = { fontSize: rem(72), lineHeight: lineHeight(90) };
        break;
      }
      case "DisplayXL": {
        styleBasedOnType = { fontSize: rem(60), lineHeight: lineHeight(72) };
        break;
      }
      case "DisplayLG": {
        styleBasedOnType = { fontSize: rem(48), lineHeight: lineHeight(60) };
        break;
      }
      case "DisplayMD": {
        styleBasedOnType = { fontSize: rem(36), lineHeight: lineHeight(44) };
        break;
      }
      case "DisplaySM": {
        styleBasedOnType = { fontSize: rem(30), lineHeight: lineHeight(38) };
        break;
      }
      case "DisplayXS": {
        styleBasedOnType = { fontSize: rem(24), lineHeight: lineHeight(32) };
        break;
      }
      case "TextXL": {
        styleBasedOnType = { fontSize: rem(20), lineHeight: lineHeight(30) };
        break;
      }
      case "TextLG": {
        styleBasedOnType = { fontSize: rem(18), lineHeight: lineHeight(28) };
        break;
      }
      case "TextMD": {
        styleBasedOnType = { fontSize: rem(16), lineHeight: lineHeight(24) };
        break;
      }
      case "TextSM": {
        styleBasedOnType = { fontSize: rem(14), lineHeight: lineHeight(20) };
        break;
      }
      case "TextXS": {
        styleBasedOnType = { fontSize: rem(12), lineHeight: lineHeight(18) };
        break;
      }
      default:
        break;
    }
    return {
      ...styleBasedOnType,
      ...(disabled ? { color: theme.palette.action.disabled } : {}),
    };
  }
);
